import { useSelector } from 'react-redux';
import { getOverLayListLoader } from 'redux/selectors';
import LinearProgress from '@mui/material/LinearProgress';
import styles from '../userList.module.css';

export default function UserListEmpty() {
	const listLoader = useSelector(getOverLayListLoader);
	return listLoader ? (
		<LinearProgress />
	) : (
		<div className={styles.userListEmptyRoot}>No Records Found</div>
	);
}
